import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { isAdmin } from 'utils/common';

const AdminGuard = ({ children }) => {
  if (!isAdmin()) {
    return <Navigate to="/panel/404" replace />;
  }

  return children;
};

AdminGuard.propTypes = {
  children: PropTypes.node
};
export default AdminGuard;
